const {BASE_URL} = require('./client');

const GET_MENTORS = BASE_URL + '/api/mentor/get';
module.exports = {
    GET_MENTORS
}